import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaTipoVehiculo(combo = false) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-vehiculo/obtener-lista-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("DD/MM/YYYY HH:mm");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.descripcion,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaTipoVehiculo err");
        console.log(err);
        return [];
    }
}

export async function crearTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-vehiculo/crear-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-vehiculo/actualizar-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/tipo-vehiculo/deshabilitar-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}